import { z } from 'zod';
import { cardListSchema } from './card';
import { reconciliationSchema } from './cross-board-move';
import { ulidSchema } from './id';

const BULK_CARD_LIMIT = 20;

export const bulkCardIdsSchema = z
  .array(ulidSchema)
  .min(1)
  .max(BULK_CARD_LIMIT)
  .superRefine((cardIds, context) => {
    const seen = new Set<string>();
    for (const [index, cardId] of cardIds.entries()) {
      if (seen.has(cardId)) {
        context.addIssue({
          code: 'custom',
          path: [index],
          message: 'Card ids in a bulk action must be unique.',
        });
      }
      seen.add(cardId);
    }
  });

export const bulkCardArchiveBodySchema = z.strictObject({
  cardIds: bulkCardIdsSchema,
});

export type BulkCardArchiveBody = z.infer<typeof bulkCardArchiveBodySchema>;

const bulkCardPositionBodyShape = {
  cardIds: bulkCardIdsSchema,
  listId: ulidSchema,
  previousCardId: ulidSchema.nullable().default(null),
  nextCardId: ulidSchema.nullable().default(null),
} as const;

export const bulkCardMoveBodySchema = z.strictObject(bulkCardPositionBodyShape);

export type BulkCardMoveBody = z.infer<typeof bulkCardMoveBodySchema>;

export const bulkCardCopyBodySchema = z.strictObject({
  ...bulkCardPositionBodyShape,
  keepChecklists: z.boolean().default(true),
  keepLabels: z.boolean().default(true),
  keepMembers: z.boolean().default(true),
  keepAttachments: z.boolean().default(true),
  keepDates: z.boolean().default(true),
});

export type BulkCardCopyBody = z.infer<typeof bulkCardCopyBodySchema>;

export const bulkCardsChangedSchema = z.object({
  cards: cardListSchema,
  count: z.number().int().nonnegative(),
});

export type BulkCardsChanged = z.infer<typeof bulkCardsChangedSchema>;

export const bulkCardCopyResultSchema = bulkCardsChangedSchema.extend({
  reconciliation: reconciliationSchema,
});

export type BulkCardCopyResult = z.infer<typeof bulkCardCopyResultSchema>;
